<template>
  <div class="flex-row page space-x-12  ">
    <div class="flex-col shrink-0 relative section">
      <div class="flex-col group">
        <span class="self-start font_1">长度：</span>
        <span class="font_2 text">256 ｍｍ</span>
        <div class="section_2"></div>
      </div>
      <div class="flex-col group view">
        <span class="self-start font_1">宽度：</span>
        <span class="font_2 text">256 ｍｍ</span>
        <div class="section_2"></div>
      </div>
      <div class="flex-col group_2 space-y-18">
        <div class="flex-col self-center group_3 space-y-8">
          <span class="self-start font_1 text_2">面积：</span>
          <span class="font_2 text_3">256 ｍｍ²</span>
        </div>
        <div class="flex-col">
          <!-- <span class="font_3 text_4">注：双击选择根系</span> -->
          <div class="flex-col justify-start items-center button text-wrapper">
            <span class="font_3 text_5" @click="handleBack"> 返回</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <img class="flex-auto image" src="../../../assets/images/gen_root4.jpg" />
    </div>
  </div>
</template>

<script>

export default {

  data () {
    return {

    }
  },

  created () {
    const rootSettingReload = sessionStorage.getItem("_rootSetting_reload_")



    if (rootSettingReload == 'true') {
      sessionStorage.setItem("_rootSetting_reload_", false)
      window.location.reload()
    }
  },

  methods: {
    handleBack () {
      this.$router.back()
    }
  }
}
</script>

<style>
html,
body {
  overflow-x: clip !important;
}
</style>
<style lang="scss" scoped>
@import "./../codeFunCommon.scss";

.page {
  padding: 20px;
  background-color: #f7f7f7;
  width: 100%;
  height: 100%;

  transform: rotate(90deg);

  .section {
    padding: 24px 14px 0;
    background-color: #ffffffcc;
    border-radius: 10px;
    box-shadow: 0px 10.5px 6px #3981f60d;
    width: 151px;

    .group {
      padding-left: 28px;
      padding-right: 20px;
      .text {
        margin-top: 12px;
      }
      .section_2 {
        margin-top: 20px;
        background-color: #e9ecf2;
        height: 1px;
      }
    }
    .view {
      margin-top: 22px;
    }
    .group_2 {
      padding: 22px 0 12px;
      .group_3 {
        // width: 81px;
        .text_2 {
          line-height: 14.5px;
        }
        .text_3 {
          line-height: 22px;
        }
      }
      .space-y-8 {
        & > *:not(:first-child) {
          margin-top: 8px;
        }
      }
      .font_3 {
        font-size: 14px;
        font-family: PingFang SC;
        line-height: 13.5px;
      }
      .text_4 {
        margin-left: 8px;
        color: #808d9e;
        line-height: 13px;
      }
      .button {
        margin-top: 20px;
        border: 1px solid #2a85ff;

        .text_5 {
          color: #2a85ff;
          line-height: 12.5px;
          letter-spacing: 3.5px;
        }
      }
      .text-wrapper {
        padding: 12px 0;
        opacity: 0.8;
        background-color: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 4px 4px #3981f60d;
        width: 123.5px;
      }
    }
    .space-y-18 {
      & > *:not(:first-child) {
        margin-top: 18px;
      }
    }
    .font_1 {
      font-size: 16px;
      font-family: PingFang SC;
      line-height: 15px;
      color: #333333;
    }
    .font_2 {
      font-size: 18px;
      font-family: PingFang SC;
      line-height: 13.5px;
      font-weight: 700;
      color: #4778e7;
    }
  }
  .image {
    border-radius: 10px;
    width: 570px;
    // height: 336px;
  }
}
.space-x-12 {
  & > *:not(:first-child) {
    margin-left: 12px;
  }
}
</style>
